import { environment } from '../../environments/environment';

/**
 * Centralized configuration for all MSAL scopes used throughout the application.
 * This eliminates hard-coded scope strings and provides a single source of truth.
 */

// ========================
// SCOPE DEFINITIONS
// ========================

/**
 * Custom API scopes for your application
 */
export const API_SCOPES = {
  DEFAULT: `api://${environment.msal.apiClientId}/.default`,
} as const;

// ========================
// SCOPE COMBINATIONS
// ========================

/**
 * Standard login scopes for initial authentication
 */
export const LOGIN_SCOPES = ['openid', 'profile', 'email', API_SCOPES.DEFAULT];

/**
 * API access scopes for backend communication
 */
export const API_ACCESS_SCOPES = [API_SCOPES.DEFAULT];

// ========================
// PROTECTED RESOURCE MAP
// ========================

/**
 * Map of protected resources and their required scopes
 */
export const PROTECTED_RESOURCES = new Map<string, string[]>([
  [environment.apiUrl, API_ACCESS_SCOPES],
  [`${environment.apiUrl}/api`, API_ACCESS_SCOPES],
]);

// ========================
// REQUEST CONFIGURATIONS
// ========================

/**
 * Login request configuration
 */
export const loginRequest = {
  scopes: LOGIN_SCOPES,
  extraQueryParameters: {
    domain_hint: 'organizations',
  },
  prompt: 'select_account',
};

/**
 * API request configuration for token acquisition
 */
export const apiRequest = {
  scopes: API_ACCESS_SCOPES,
};

/**
 * Silent token request configuration
 */
export const silentRequest = {
  scopes: API_ACCESS_SCOPES,
};
